import { isNull, omitBy } from 'lodash';

export const createDDBItem = (data: any) => {
  return omitBy(
    {
      name: data.name,
      url: data.url,
      is_active: data.is_active,
    },
    isNull,
  );
};
